import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export enum IntegrationStatusFilter {
  active = 'active',
  failed = 'failed',
  inactive = 'inactive',
}

export const IntegrationStatusToApiValue: Record<string, string> = {
  [IntegrationStatusFilter.active]: 'active',
  [IntegrationStatusFilter.failed]: 'failing',
  [IntegrationStatusFilter.inactive]: 'disabled',
};

export const IntegrationStatusSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.IntegrationStatus}-${IntegrationStatusFilter.active}`,
    value: IntegrationStatusFilter.active,
    displayName: 'Active',
    filterType: FilterTypesEnum.IntegrationStatus,
    categoryName: FilterTypesEnum.IntegrationStatus.toString(),
  },
  {
    id: `${FilterTypesEnum.IntegrationStatus}-${IntegrationStatusFilter.inactive}`,
    value: IntegrationStatusFilter.inactive,
    displayName: 'Inactive',
    filterType: FilterTypesEnum.IntegrationStatus,
    categoryName: FilterTypesEnum.IntegrationStatus.toString(),
  },
  {
    id: `${FilterTypesEnum.IntegrationStatus}-${IntegrationStatusFilter.failed}`,
    value: IntegrationStatusFilter.failed,
    displayName: 'Failed',
    filterType: FilterTypesEnum.IntegrationStatus,
    categoryName: FilterTypesEnum.IntegrationStatus.toString(),
  },
];

export const IntegrationStatusDefaultSelectedIds: string[] = [
  `${FilterTypesEnum.IntegrationStatus}-${IntegrationStatusFilter.active}`,
];

export const IntegrationStatusDefaultValues: string[] = [IntegrationStatusFilter.active];
